import { useState, useEffect } from 'react'
import './FormComp.css'
import { useFormik } from 'formik'
import axios from 'axios';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import PageResetComp from '../page-reset/PageResetComp';
import { API_URL, CAMPAIGN_ID_CONTACT, VISAKA_SERVICES_API_URL } from '../../../../config/config';
//import { useParams } from 'react-router-dom';
import CleanNumericInput from './CleanNumericInput';



const ContactFormComp = () => {

    const [searchParams] = useSearchParams();
    const location = useLocation();

    const cId = searchParams.get('c_id') || null;
    const campaignId = cId && cId.trim() !== "" ? cId : CAMPAIGN_ID_CONTACT;
    const source = searchParams.get('src') || null;
    const campaignSource = source && source.trim() !== "" ? source : 'website';

    // START GEO SERVICES HOOKS
    const [stateList, setStateList] = useState([]);
    const [districtList, setDistrictList] = useState([]);
    const [allDistricts, setAllDistricts] = useState([]);
    const [zoneList, setZoneList] = useState([]);
    // END GEO SERVICES HOOKS

    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);

    const formik  = useFormik({
        initialValues:{
            name:"",
            email: "",
            phone_number:"",
            state:"",
            district:"",
            city:"",
            category:"",
            campaign_id:"",
            source:"",
            zonal_name:""
        },
        onSubmit:(values)=>{
            const formData = new FormData(); 
            formData.append("name", values.name);
            formData.append("email", values.email);
            formData.append("phone_number", values.phone_number);
            formData.append("state", values.state);
            formData.append("district", values.district);
            formData.append("city", values.city);
            formData.append("category", values.category);
            formData.append("campaign_id", campaignId); 
            formData.append("source", campaignSource);
            formData.append("zonal_name", values.zonal_name);  
            setIsLoading(true);
            axios.post(`${API_URL}vnext/enquiries/create`, formData)
            .then(response=>
                {
                    formik.resetForm();
                    response.data.status === 200 ? navigate(`/success${location.search}`) : navigate('/error')
                    setIsLoading(false);
                }
            )
            .catch(err=> {
                console.log(err);
                setIsLoading(false);
            })
        },
        validate:(values)=>{
            let errors = {};
            if(!values.name){
                errors.name="Full Name is required"
            }else if(values.name.length < 3){
                errors.name="Name Should be Minimum 3 letters"
            }
            // else if (!/^[A-Za-z\s]+$/.test(values.name)) {
            //     errors.name = "Name should contain only letters";
            // }
            if(!values.email){
                errors.email="Email is required"
            }
            else if (
                !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
              ) {
                errors.email = 'Invalid Email address';
            }
            if(!values.phone_number){
                errors.phone_number="Mobile Number is required"
            }
            else if(values.phone_number.length!==10){
                errors.phone_number = 'Mobile Number Must Be 10 Digits';
            }
            else if (!/^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/i.test(values.phone_number)) {
                errors.phone_number = 'Please Enter Numbers format only';
            }
            
            if(!values.category){
                errors.category="Category is required"
            }
            if(!values.state){
                errors.state="State is required"
            }
            if(!values.district){
                errors.district="District is required"
            }
            if(!values.city){
                errors.city="City is required"
            }
            return errors;
        }
     });

    


    // START GEO SERVICES API FOR STATE & DISTRICT DROPDOWNS
     useEffect(() => {    
        const fetchStateDistrictInfo = async () => {
            const response = await fetch(VISAKA_SERVICES_API_URL + "api/v2/geoservice/district/IN");
            const data = await response.json();
        
            setStateList(data.state);
            setAllDistricts(data.district);
            setZoneList(data.zones); // <== make sure you set this
        };

        fetchStateDistrictInfo();
    }, []);
    
    const handleStateDistrict = (e) => {
        const selectedStateName = e.target.value;
        formik.setFieldValue('state', selectedStateName);
    
        // Find the selected state using state_name
        const selectedStateObj = stateList.find(
            (state) => state.state_name === selectedStateName
        );
    
        if (selectedStateObj) {
            // Get zonal_name using zonal_code
            const zoneObj = zoneList.find(
                (zone) => zone.zonal_code === selectedStateObj.zonal_code
            );
    
            if (zoneObj) {
                formik.setFieldValue('zonal_name', zoneObj.zonal_name);
            } else {
                formik.setFieldValue('zonal_name', '');
            }
    
            // Filter districts by state_code
            const filteredDistricts = allDistricts.filter(
                (dist) => dist.state_code === selectedStateObj.state_code
            );
            setDistrictList(filteredDistricts);
        } else {
            // Clear if not found
            setDistrictList([]);
            formik.setFieldValue('zone', '');
        }
    };
    // END GEO SERVICES API FOR STATE & DISTRICT DROPDOWNS

  return (
    <>  
        {isLoading && <PageResetComp />}
        <div className='shadow p-5 rounded'>
            <form autoComplete='off' onSubmit={formik.handleSubmit}>
                <input type='hidden' name='zonal_name' value={formik.values.zonal_name} />
                <div className="form-floating mb-3">
                    <input type="text" className="form-control"  value={formik.values.name} onChange={formik.handleChange} name="name" placeholder="Enter Full Name" />
                    <label htmlFor="floatingInput">Enter Full Name</label>
                    {formik.errors.name?<span className='text-danger mt-2 d-block'>{formik.errors.name}</span> : null}
                </div>
                <div className="form-floating mb-3">
                    <input type="text" className="form-control"  value={formik.values.email} onChange={formik.handleChange} name="email" placeholder="Enter email" />
                    <label htmlFor="floatingInput">Enter Email</label>
                    {formik.errors.email? <span className='text-danger mt-2 d-block'>{formik.errors.email}</span> : null}
                </div>
                <div className="form-floating mb-3">
                    {/* <input type="text" className="form-control"  maxLength={10} value={formik.values.phone_number} onChange={formik.handleChange} name="phone_number" placeholder="Enter mobile No."/> */}
                    <input type="text" className="form-control" maxLength={10} value={formik.values.phone_number} name="phone_number" placeholder="Enter mobile No."
                        onChange={(e) => {
                            const cleaned = CleanNumericInput(e.target.value);
                            formik.setFieldValue('phone_number', cleaned);
                        }}
                        onPaste={(e) => {
                            e.preventDefault();
                            const pasted = e.clipboardData.getData('Text');
                            const cleaned = CleanNumericInput(pasted);
                            formik.setFieldValue('phone_number', cleaned);
                        }}
                        onBlur={(e) => {
                            const cleaned = CleanNumericInput(e.target.value);
                            formik.setFieldValue('phone_number', cleaned);
                        }}
                    />
                    <label htmlFor="floatingInput">Enter Mobile No.</label>
                    {formik.errors.phone_number? <span className='text-danger mt-2 d-block'>{formik.errors.phone_number}</span> : null}
                </div>
                <div className="form-floating mb-3">
                    <select className="form-select form-control"  value={formik.values.category} onChange={formik.handleChange} name="category"> 
                        <option value="">Select Category</option>
                        <option value="Architect">Architect</option>
                        <option value="Interior">Interior</option>
                        <option value="Builder">Builder</option>
                        <option value="Contractor">Contractor</option>
                        <option value="Dealership">Dealership</option>
                        <option value="Item enquiry">Item Enquiry</option>
                        <option value="Order enquiry">Order enquiry</option>
                        <option value="Others">Others</option>
                    </select>
                    <label htmlFor="floatingInput">Select Category</label>
                    {formik.errors.category? <span className='text-danger mt-2 d-block'>{formik.errors.category}</span> : null}
                </div>
                {/* <div className='form-floating mb-3'>
                    <select className="form-select" name="state" onChange={handleStateDistrict}  value={formik.values.state}>
                        <option defaultValue>Select State*</option>
                        {regional && Array.from(new Set(regional.map(obj => obj.State))).map((State, index) => {
                            return (<option value={State} key={index}>{State}</option>)
                        })}
                    </select>
                    <label htmlFor="floatingInput">Select State</label>
                    {formik.errors.state? <span className='text-danger mt-2 d-block'>{formik.errors.state}</span> : null}
                </div>
                <div className='form-floating mb-3'>
                    <select className="form-select" name="district"  onChange={formik.handleChange} value={formik.values.district}>
                        <option defaultValue>Select District*</option>
                        {
                            district.map((edist, index) => {
                                return (
                                    <option key={index}>{edist.District}</option>
                                )
                            })
                        }
                    </select>
                    <label htmlFor="floatingInput">Select District</label>
                    {formik.errors.district? <span className='text-danger mt-2 d-block'>{formik.errors.district}</span> : null}
                </div> */}
                <div className='form-floating mb-3'>
                    <select className="form-select" name="state" onChange={handleStateDistrict} value={formik.values.state}>
                        <option value="">Select State*</option>
                        {stateList.map((state) => (
                            <option value={state.state_name} key={state.id}>
                                {state.state_name}
                            </option>
                        ))}
                    </select>
                    <label>Select State</label>
                    {formik.errors.state && <span className='text-danger mt-1 d-block'>{formik.errors.state}</span>}
                </div>
                <div className='form-floating mb-3'>
                    <select className="form-select" name="district" onChange={formik.handleChange} value={formik.values.district}>
                        <option value="">Select District*</option>
                        {districtList.map((dist) => (
                            <option value={dist.district_name} key={dist.id}>
                                {dist.district_name}
                            </option>
                        ))}
                    </select>
                    <label>Select District</label>
                    {formik.errors.district && <span className='text-danger mt-1 d-block'>{formik.errors.district}</span>}
                </div>
                <div className="form-floating mb-3">
                    <input type="text" className="form-control" value={formik.values.city} onChange={formik.handleChange} name="city" placeholder="Enter City"/>
                    <label htmlFor="floatingInput">Enter City</label>
                    {formik.errors.city? <span className='text-danger mt-2 d-block'>{formik.errors.city}</span> : null}
                </div>
                <div className="mt-4 d-flex gap-3 justify-content-center">
                    <input type="submit" className="btn w-100 rounded bg-theme border-0 py-3 text-uppercase fw-bold" value={isLoading ? "Processing..." : "Submit"} disabled={isLoading} />
                </div>
            </form>  
        </div> 
    </>
  )
}
export default ContactFormComp